var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInitiativeLeaf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 3.37501C6.79922 3.37501 4.46133 5.18555 3.6668 7.68165C4.84805 7.08399 6.18047 6.75001 7.59375 6.75001H10.6875C10.9969 6.75001 11.25 7.00313 11.25 7.31251C11.25 7.62188 10.9969 7.87501 10.6875 7.87501H10.125H7.59375C7.01016 7.87501 6.44414 7.9418 5.89922 8.06485C4.98867 8.27227 4.14141 8.64141 3.38906 9.14415C1.34648 10.5047 0 12.8285 0 15.4688V16.0313C0 16.4988 0.376172 16.875 0.84375 16.875C1.31133 16.875 1.6875 16.4988 1.6875 16.0313V15.4688C1.6875 13.7566 2.41523 12.2168 3.57891 11.1375C4.275 13.7918 6.69023 15.75 9.5625 15.75H9.59766C14.2418 15.7254 18 11.1481 18 5.50548C18 4.00782 17.7363 2.58399 17.2582 1.30079C17.1668 1.05821 16.8117 1.06876 16.6887 1.29727C16.0277 2.53477 14.7199 3.37501 13.2188 3.37501H9.5625Z",
    fill: "#054254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiativeLeaf);
export default __webpack_public_path__ + "static/media/initiative-leaf.e6c12cb0f9dd8c6b3ff80c684deb207a.svg";
export { ForwardRef as ReactComponent };